import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {jwtDecode} from 'jwt-decode';
import { jobTypes} from '../utils/data';
import JobCard from '../components/JobCard';
import { useParams } from 'react-router-dom';
import SuccessAlert from '../components/sucessalert';

const InputField = ({ label, name, placeholder, value, onChange, type = "text", required }) => (
  <div className="w-full">
     <label htmlFor={name} className="block text-sm font-medium text-gray-700">{label}</label>
     <input
       id={name}
       name={name}
       placeholder={placeholder}
       type={type}
       value={value}
       onChange={onChange}
       className="w-full p-2 border border-gray-300 rounded"
       required={required}
     />
  </div>
 );
 
 const SelectField = ({ label, name, value, onChange, options, required }) => (
  <div className="w-full">
     <label htmlFor={name} className="block text-sm font-medium text-gray-700">{label}</label>
     <select
       id={name}
       name={name}
       value={value}
       onChange={onChange}
       className="w-full p-2 border border-gray-300 rounded"
       required={required}
     >
       {options.map((option, index) => (
         <option key={index} value={option}>{option}</option>
       ))}
     </select>
  </div>
 );
 

const UploadJob = () => {
  const { id } = useParams();
  const [info, setInfo] = useState(null);
  const [jobs, setJobs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [role, setRole] = useState("seeker");
  const [profileUrl, setProfileUrl] = useState("");
  const [isCompany, setIsCompany] = useState(false);
  const[sucess, setSucess]=useState('');
 const [formData, setFormData] = useState({
    jobTitle: '',
    jobType: 'Full-Time',
    location: '',
    salary: '',
    vacancies: '',
    experience: '',
    requirements: '',
    desc: '',
 });
 useEffect(() => {
  const userToken = localStorage.getItem('token');
  const checkRole = localStorage.getItem('role');
  setRole(checkRole);
  if (userToken) {
    try {
      const decoded = jwtDecode(userToken);
      const userId = decoded.userId;
      
      if (userId === id) {
        setIsCompany(true);
      }
    } catch (error) {
      console.error('Error decoding token:', error);
    }
  }
}, [id]);

useEffect(() => {
const fetchData = async () => {
  setIsLoading(true);
  try {
    let userId = id; // First attempt to use id from URL parameters

    if (!userId) {
      const userToken = localStorage.getItem("token");
      if (userToken) {
        try {
          const decoded = jwtDecode(userToken);
          userId = decoded.userId; // Fallback to using userId from decoded token
        } catch (error) {
          console.error("Token verification failed:", error.message);
        }
      }
    }

    if (userId) {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/company/get-company-joblisting`, {
        id: userId
      });
      setJobs(response.data.companies.jobPosts || []);
      setProfileUrl(response.data.companies.profileUrl);
      setInfo(response.data.companies);
    }
    setIsLoading(false);
  } catch (error) {
    console.error('Error fetching job listings:', error);
    setIsLoading(false);
  }
};
fetchData();
}, [id]);


 const [errMsg, setErrMsg] = useState('');

 const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(info ,isLoading, isCompany,role);

    const userToken = window.localStorage.getItem("token");
    if (!userToken) {
      setErrMsg('User token not found. Please log in.');
      return;
    }

    try {
      const decoded = jwtDecode(userToken);
      const userId = decoded.userId;

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/job/upload-job`,
        { ...formData, company: userId },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      console.log('Job uploaded successfully:', response.data);
      setSucess(true);
      // Optionally, clear the form or show a success message
    } catch (error) {
      console.error('Error uploading job:', error);
      setErrMsg('Error uploading job. Please try again later.');
    }
 };

 const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
 };

 return (
    <div className="container mx-auto flex flex-col md:flex-row gap-8 2xl:gap-14 bg-[#f7fdfd] px-5">
      <div className="w-full h-fit md:w-2/3 2xl:2/4 bg-white px-5 py-10 md:px-10 shadow-md">
        <p className="text-gray-500 font-semibold text-2xl">Job Post</p>
        <form className="w-full mt-2 flex flex-col gap-8" onSubmit={handleSubmit}>
 <InputField
    label="Job Title"
    name="jobTitle"
    placeholder="eg. Software Engineer"
    value={formData.jobTitle}
    onChange={handleInputChange}
    required
 />
 <SelectField
    label="Job Type"
    name="jobType"
    value={formData.jobType}
    onChange={handleInputChange}
    options={jobTypes}
    required
 />
 <InputField
    label="Location"
    name="location"
    placeholder="eg. New York"
    value={formData.location}
    onChange={handleInputChange}
    required
 />
 <InputField
    label="Salary"
    name="salary"
    placeholder="eg. 1500"
    type="number"
    value={formData.salary}
    onChange={handleInputChange}
    required
 />
 <InputField
    label="Vacancies"
    name="vacancies"
    placeholder="eg. 3"
    type="number"
    value={formData.vacancies}
    onChange={handleInputChange}
    required
 />
 <InputField
    label="Experience"
    name="experience"
    placeholder="eg. 2"
    type="number"
    value={formData.experience}
    onChange={handleInputChange}
    required
 />
 <textarea
    label="Requirements"
    name="requirements"
    className='rounded border border-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 text-base px-4 py-2 resize-none'
                rows={4}
                cols={6}
    placeholder="eg. Technical skills, qualifications, etc."
    value={formData.requirements}
    onChange={handleInputChange}
    required
 />
 <textarea
    label="Description"
    name="desc"
    className='rounded border border-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 text-base px-4 py-2 resize-none'
                rows={4}
                cols={6}
    placeholder="eg. Description text"
    value={formData.desc}
    onChange={handleInputChange}
    required
 />
 <button
    type="submit"
    className="w-full p-2 bg-blue-500 text-white rounded hover:bg-blue-600"
 >
    Submit
 </button>
 {errMsg && (
    <span role="alert" className="text-sm text-red-500 mt-0.5">
      {errMsg}
    </span>
 )}
</form>


      </div>
      {/* Sidebar with recent job posts */}
<div className="w-full md:w-1/3 2xl:2/4 p-5 mt-20 md:mt-0">
        <p className="text-gray-500 font-semibold">Recent Job Post</p>
        <div className="w-full flex flex-wrap gap-6">
          {jobs.slice(0, 4).map((job, index) => (
            <JobCard job={job} key={index}  profileUrl={profileUrl}/>
          ))}
        </div>
      </div>
      {sucess &&(
        <SuccessAlert title={`Job created Sucessfully`}
         text={'Now Candidate can apply on Your jobs'} link={'/find-jobs'}/>
      )}
    </div>
    
 );
};

export default UploadJob;
